import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormatters } from '../../../utils/format';
import Icon from '../../../components/AppIcon';

const CompensationOverview = ({ compensationData }) => {
  const { t } = useTranslation();
  const { eur } = useFormatters();

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-soft">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">
          {t('employeePortal.compensation.cardTitle')}
        </h2>
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Calendar" size={16} />
          <span>{t('employeePortal.compensation.effective', { date: compensationData?.effectiveDate })}</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Base Salary */}
        <div className="bg-muted/30 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="DollarSign" size={20} className="text-primary" />
            <h3 className="font-medium text-foreground">
              {t('employeePortal.compensation.baseSalary')}
            </h3>
          </div>
          <p className="text-2xl font-bold text-foreground">{eur(compensationData?.baseSalary)}</p>
          <p className="text-sm text-muted-foreground mt-1">
            {t('employeePortal.compensation.annualGrossAmount')}
          </p>
        </div>

        {/* Variable Pay */}
        <div className="bg-muted/30 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="TrendingUp" size={20} className="text-accent" />
            <h3 className="font-medium text-foreground">
              {t('employeePortal.compensation.variablePay')}
            </h3>
          </div>
          <p className="text-2xl font-bold text-foreground">{eur(compensationData?.variablePay)}</p>
          <p className="text-sm text-muted-foreground mt-1">
            {t('employeePortal.compensation.targetBonus')}
          </p>
        </div>

        {/* Total Compensation */}
        <div className="bg-primary/10 rounded-lg p-4 border border-primary/20">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Wallet" size={20} className="text-primary" />
            <h3 className="font-medium text-foreground">
              {t('employeePortal.compensation.totalCompensation')}
            </h3>
          </div>
          <p className="text-2xl font-bold text-primary">{eur(compensationData?.totalCompensation)}</p>
          <p className="text-sm text-muted-foreground mt-1">
            {t('employeePortal.compensation.baseVarBenefits')}
          </p>
        </div>
      </div>

      {/* Additional Benefits */}
      <div className="mt-6 pt-6 border-t border-border">
        <h4 className="font-medium text-foreground mb-4">
          {t('employeePortal.compensation.additionalBenefits')}
        </h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-3 gap-x-6 gap-y-3">
          {compensationData?.benefits?.map((benefitKey, index) => (
            <div key={index} className="flex items-start gap-2 min-w-0">
              <Icon name="Check" size={16} className="text-success shrink-0 mt-0.5" />
              <span className="text-sm text-foreground leading-snug break-words hyphens-auto">{t(benefitKey)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompensationOverview;
